function numOrZero(v) {
  if (v == null || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Split customer discount into salon-issued vs Ulloor Styles platform offers.
 * Uses the same field fallbacks as the salon dashboard pricing breakdown.
 *
 * @returns {{
 *   salonOfferAmount: number,
 *   ulloorOfferAmount: number,
 *   otherDiscountAmount: number,
 *   totalDiscountAmount: number
 * }}
 */
export function getBookingOfferBreakdown(booking) {
  if (!booking || typeof booking !== 'object') {
    return {
      salonOfferAmount: 0,
      ulloorOfferAmount: 0,
      otherDiscountAmount: 0,
      totalDiscountAmount: 0
    };
  }

  const totalPrice = numOrZero(booking.totalPrice);
  const original = numOrZero(booking.originalPrice ?? booking.servicePrice);

  let storedDiscount = NaN;
  if (booking.discountAmount != null && booking.discountAmount !== '') {
    storedDiscount = Math.abs(Number(booking.discountAmount));
  }
  if (!Number.isFinite(storedDiscount)) {
    storedDiscount = Math.max(0, original - totalPrice);
  }

  const rawSalon =
    booking.salonDiscountAmount ??
    booking.salon_discount_amount ??
    booking.salonOfferDiscountAmount ??
    booking.salon_offer_discount_amount;
  let salonOffer = rawSalon != null && rawSalon !== '' ? Math.abs(Number(rawSalon)) : 0;
  if (!Number.isFinite(salonOffer)) salonOffer = 0;

  const subRaw = booking.subtotalBeforePlatformOffers ?? booking.subtotal_before_platform_offers;
  const subNum = subRaw != null && subRaw !== '' ? Number(subRaw) : NaN;
  if (salonOffer === 0 && Number.isFinite(subNum) && original > subNum) {
    salonOffer = original - subNum;
  }

  const rawUlloor =
    booking.ulloorCustomOfferDiscountAmount ?? booking.ulloor_custom_offer_discount_amount;
  let ulloorOffer = rawUlloor != null && rawUlloor !== '' ? Math.abs(Number(rawUlloor)) : 0;
  if (!Number.isFinite(ulloorOffer)) ulloorOffer = 0;

  const sumParts = salonOffer + ulloorOffer;
  const remainder = Math.max(0, storedDiscount - sumParts);
  const otherDiscount = remainder > 0.5 ? remainder : 0;

  return {
    salonOfferAmount: salonOffer,
    ulloorOfferAmount: ulloorOffer,
    otherDiscountAmount: otherDiscount,
    totalDiscountAmount: storedDiscount
  };
}

/**
 * Aggregate offer breakdowns for a list of bookings.
 */
export function sumOfferBreakdowns(bookings) {
  return bookings.reduce(
    (acc, b) => {
      const o = getBookingOfferBreakdown(b);
      acc.salonOfferAmount += o.salonOfferAmount;
      acc.ulloorOfferAmount += o.ulloorOfferAmount;
      acc.otherDiscountAmount += o.otherDiscountAmount;
      acc.totalDiscountAmount += o.totalDiscountAmount;
      return acc;
    },
    {
      salonOfferAmount: 0,
      ulloorOfferAmount: 0,
      otherDiscountAmount: 0,
      totalDiscountAmount: 0
    }
  );
}
